export default __webpack_public_path__ + "static/media/Punto_11_Palazzi_dell_800_DEU_Def.69a27e6b.aac";